import { Component, Input } from '@angular/core';
import { AuthService } from '@core/services/auth/auth.service';
import { Notification } from '@modules/notification/interface/notification.interface';
import { NotificationService } from '@modules/notification/service/notification.service';
import { SanitizerPipe } from '@shared/pipes/sanitizer.pipe';
import { UserResponse } from '@shared/interfaces/users.interface';
import { ThemeService } from '@shared/services/theme/theme.service';
import { TimeAgoPipe } from '@shared/pipes/time-ago.pipe';
import { FilterService } from '@modules/search/services/filter.service';
import { Router } from '@angular/router';

interface NotificationHeader {
  comment : string,
  workspace : string,
  reminder : string,
  shared : string,
  claim_comment : string,
  report_comment : string,
  claim_status_change : string,
  claim_assignment : string
}

@Component({
  selector: 'app-notification-card',
  standalone: true,
  imports: [
    SanitizerPipe,
    TimeAgoPipe
  ],
  templateUrl: './notification-card.component.html',
  styleUrl: './notification-card.component.scss'
})
export class NotificationCardComponent {

  @Input() notification: Notification = {} as Notification;
  userListByEmail: { [email: string]: UserResponse };
  notificationHeader: NotificationHeader = {
    "comment" : "mentioned you on a mail",
    "workspace" : "added you to a mail",
    "reminder" : "You have set a reminder for this email",
    "shared" : "shared an email with you",
    "claim_comment" : "mentioned you in a comment on a claim",
    "report_comment" : "mentioned you in a comment on a report",
    "claim_status_change" : "changed the status of a claim",
    "claim_assignment" : "assigned a claim to you"
  };

  constructor(
    private notificationService : NotificationService,
    private _auth : AuthService,
    private themeService : ThemeService,
    private _filter : FilterService,
    private router : Router
  ) {
    this.userListByEmail = this._auth.userByEmail;
  }


  markNotificationAsViewed() {
    this.notificationService.markNotificationAsViewed({id : this.notification._id}).subscribe({
      next: (data)=>{
      },
      error: (err)=>{
        console.log("err", err);
      }
    })
  }

  handleNotificationClick = () => {
    // Mark notification as viewed
    this.markNotificationAsViewed();

    // Close the notification dialog
    this.notificationService.isNotificationDialogVisible = false;

    // Navigate based on context
    const route = this.notificationService.getNavigationRoute(this.notification.context);

    if (this.notification.context === 'claim_comment') {
      // For claim comments, navigate with entityId and openSidebar flag
      this.router.navigate([route], {
        queryParams: {
          claimId: this.notification.entityId,
          openSidebar: 'true'
        }
      });
    } else if (this.notification.context === 'report_comment') {
      // For report comments, navigate with entityId and openSidebar flag
      this.router.navigate([route], {
        queryParams: {
          reportId: this.notification.entityId,
          openSidebar: 'true'
        }
      });
    } else if (this.notification.context === 'claim_status_change' || this.notification.context === 'claim_assignment') {
      // For claim status change or assignment notifications, navigate to claims with claimId
      this.router.navigate([route], {
        queryParams: {
          claimId: this.notification.entityId,
          openSidebar: 'true'
        }
      });
    } else {
      // For legacy notifications (shared, workspace, etc.), use filter
      this.router.navigate([route]);
      if (this.notification.esId) {
        this.applySearchFilter();
      }
    }
  }

  applySearchFilter = () => {
    let messageIdFilter = {
      "name": "message id",
      "esName": "metaData.message-id",
      "value": this.notification.esId,
      "logicalOperator": "must",
      "matchType": "exact",
      "type": "filter"
    }
    this._filter.applyFilterAndSelectFirst([messageIdFilter]);
  }

  getColorOnName(name: string): string {
    return this.themeService.getColorOnName(name);
  }

  getLightColorOnColorName(name:string): string {
    const colorOnName = this.themeService.getColorOnName(name);
    return this.themeService.lightenHexColor(colorOnName, 80);
  }

}
